import * as Font from "@faire/web/slate/Font";
import styled from "styled-components";

export const TileContainer = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  font-family: ${Font.Family.sansSerif};
  font-size: ${Font.Size.p};
  font-weight: ${Font.Weight.book};
  line-height: ${Font.LineHeight.p};
  letter-spacing: ${Font.LetterSpacing.p};
  text-align: center;
  width: 100%;
`;

export const TileImageContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const TileImage = styled.img`
  width: 100%;
  display: block;
`;
